import { MainV3ApiBase } from './base';
import { MembershipPlanIndexView } from '../types/membershipPlans';
import { ISODate } from '../../commonv3/types/dates';

export const MembershipPlanApis = {
    base() {
        return MainV3ApiBase.appendPath('membership_plans');
    },
    /**
     * @param defaultPlans returns default plans
     */
    findAll(
        defaultPlans: boolean = false,
        effectiveDate: ISODate = undefined,
        couponCode: string = undefined,
        email: string = undefined
    ): Promise<MembershipPlanIndexView[]> {
        return this.base().get({
            default: defaultPlans,
            effective_date: effectiveDate,
            coupon_code: couponCode,
            email: email,
        });
    },
};
